var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"components-back-top-demo-custom"}},[_c('router-view'),_c('a-back-top',[_c('div',{staticClass:"ant-back-top-inner"},[_c('img',{staticClass:"inner-img",attrs:{"src":_vm.backTop,"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }